import { FC } from "react"
import classNames from "classnames"

// logo mark
import letterMark from "../../../static/images/eventbrite-letter-mark.svg"

// styles
import {
  eventbriteLogo,
  eventbriteLetterMark
} from "./EventbriteLogo.module.scss"

export const EventbriteLogo: FC<{ className?: string }> = ({ className }) => {
  // return <img src={letterMark} alt="eventbrite header logo mark" />

  return (
    <>
      <div className={eventbriteLetterMark}>
        <img src={letterMark} alt="eventbrite header logo mark" />
      </div>

      <svg
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        version="1.1"
        viewBox="0 0 101 24"
        className={classNames(eventbriteLogo, className)}
      >
        <defs>
          <style>
            {`.st0 {
                fill: #FF5010;
              }`}
          </style>
        </defs>
        <g>
          <polygon
            className="st0"
            points="34.9 7.6 33 13 32.9 13 31 7.6 27.7 7.6 30.9 16.3 34.7 16.3 37.9 7.6 34.9 7.6"
          />
          <path
            className="st0"
            d="M52.9,7.3h0c-1.3,0-2.3.6-2.8,1.5v-1.3h-3.2v8.7h3.2v-4.3c0-1.3.4-2.2,1.5-2.2s1.3.6,1.3,1.8v4.6h3.2v-5.5c0-1.8-.8-3.5-3.1-3.5Z"
          />
          <path
            className="st0"
            d="M77,9.1h0v-1.5h-3.2v8.7h3.2v-4c0-1.5.7-2.1,1.9-2.1s1.3.1,1.7.4v-3c-.2-.2-.7-.3-1.2-.3-1.2,0-2.1.9-2.4,1.9Z"
          />
          <rect className="st0" x="81.1" y="7.6" width="3.2" height="8.7" />
          <circle className="st0" cx="82.7" cy="5.2" r="1.8" />
          <path
            className="st0"
            d="M89.1,12.9v-3.2h2.3v-2.2h-2.3v-2.4h-1.9c0,1.3-1.1,2.4-2.4,2.4h0v2.2h1.2v4.1c0,2,1.4,2.7,2.9,2.7s1.9-.3,2.6-.8v-2c-.5.2-1,.3-1.3.3-.6,0-1-.3-1-1h0Z"
          />
          <path
            className="st0"
            d="M61.6,14h0c-.6,0-1-.3-1-1v-3.2h2.3v-2.2h-2.3v-2.4h-1.9c0,1.3-1.1,2.4-2.4,2.4h0v2.2h1.2v4.1c0,2,1.4,2.7,2.9,2.7s1.9-.3,2.6-.8v-2c-.5.2-1,.3-1.3.3h0Z"
          />
          <path
            className="st0"
            d="M23.9,7.3c-2.7,0-4.7,2-4.7,4.7s2,4.4,4.8,4.4,4-1.3,4.4-3.3h-2.6c-.3.7-.8,1-1.7,1s-1.7-.5-1.8-1.6h6.1v-.9c0-2.4-1.5-4.3-4.4-4.3h0ZM22.3,11c.1-.8.6-1.4,1.6-1.4s1.4.7,1.5,1.4c0,0-3.1,0-3.1,0Z"
          />
          <path
            className="st0"
            d="M41.9,7.3c-2.7,0-4.7,2-4.7,4.7s2,4.4,4.8,4.4,4-1.3,4.4-3.3h-2.6c-.3.7-.8,1-1.7,1s-1.7-.5-1.8-1.6h6.1v-.9c0-2.4-1.5-4.3-4.4-4.3h0ZM40.3,11c.1-.8.6-1.4,1.6-1.4s1.4.7,1.5,1.4c0,0-3.1,0-3.1,0Z"
          />
          <path
            className="st0"
            d="M101,11.7c0-2.4-1.5-4.3-4.4-4.3s-4.7,2-4.7,4.7,2,4.4,4.8,4.4,4-1.3,4.4-3.3h-2.6c-.3.7-.8,1-1.7,1s-1.7-.5-1.8-1.6h6.1v-.9h0ZM94.9,11c.1-.8.6-1.4,1.6-1.4s1.4.7,1.5,1.4h-3.1Z"
          />
          <path
            className="st0"
            d="M69.5,7.3c-1.5,0-2.4.7-2.9,1.7V4h-3.2v12.3h2.4l.5-1.5c.5,1.1,1.6,1.7,3,1.7,2.6,0,3.9-2,3.9-4.6s-1.3-4.6-3.9-4.6h0ZM68.3,14.1c-1.1,0-1.8-.8-1.8-2.1h0c0-1.4.7-2.2,1.8-2.2s1.8.9,1.8,2.1-.6,2.1-1.8,2.1Z"
          />
        </g>
        <path
          className="st0"
          d="M13.3,15l-5.8-4.5c0,0,0-.2.1-.2l2.3,1.3c1,.6,2.3.2,3-.8.7-1.1.3-2.4-.8-3.1l-3.3-1.9c-.1,0,0-.2,0-.2l1.5.6s0,0,0,0c.2,0,.3,0,.5,0,.8,0,1.5-.7,1.6-1.4,0-1-.7-1.7-1.6-1.7H3.8c-.9,0-1.7.7-1.7,1.7,0,.5.2.9.6,1.2.3.2,1.1.9,1.5,1.2,0,0,0,.2,0,.2h-1.4c-1.5,0-2.7,1.2-2.7,2.7s.3,1.4.8,1.9l8.2,7.8c.6.5,1.4.9,2.2.9,1.8,0,3.3-1.5,3.3-3.3s-.5-1.9-1.2-2.5Z"
        />
      </svg>
    </>
  )
}
